import { useSelector } from 'react-redux'
import { roleTypes } from '../constants/common';
import { getUserPrivilege } from '../features/userid';

const RoleBasedAccessControl = ({ children, rejectedRoles = [roleTypes.hiringManager] }) => {
    const role = useSelector(getUserPrivilege);
    if (rejectedRoles.includes(role)) {
        return null;
    }
    return children;
}

export default RoleBasedAccessControl